<!-- <div class="dialing-screen-wrapper">
  <div class="dialing-screen">
    <input type="text" digitOnly [(ngModel)]="navService.dialScreenText" class="dialing-screen__input" />
    <i class="fa-light fa-delete-left dialing-screen__icon" (click)="navService.removeDialScreenText()"></i>
  </div>
</div> -->

<div class="dialing-screen-container">
  <!-- Dialing Screen -->
  <div class="dialing-screen" [ngClass]="{'dialing-screen--dialpad': themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.DEFAULT,
       'dialing-screen--revised': themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC}">
    <ng-content
      *ngTemplateOutlet="themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.DEFAULT ? dialpadInput : null"></ng-content>
    @if(themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC){
    <div class="dialer-input-wrapper">
      <ng-content *ngTemplateOutlet="dialpadInput"></ng-content>
    </div>
    }
    <i class="fa-light fa-delete-left dialing-screen__icon" (click)="onNumberRemove()"></i>
    <!-- <span class="dialing-screen__plh dialing-screen__plh--2"></span>
    <span class="dialing-screen__plh dialing-screen__plh--3"></span>
    <span class="dialing-screen__plh dialing-screen__plh--3 ml-98 mr-98"></span>
    <span class="dialing-screen__plh dialing-screen__plh--4"></span> -->
  </div>
</div>
<ng-template #dialpadInput>
  <input type="text" mask="(000) 000 0000" [showMaskTyped]="false" [(ngModel)]="number"
    (ngModelChange)="onNumberChange($event)" class="dialing-screen__input" (paste)="onPaste($event)" autofocus #myInput>
</ng-template>